<template lang="pug">
  h1 Logout
</template>


<script>
import router from '@/router';
import store from '@/store';

export default {
  name: 'logout',
  mounted() {
    window.localStorage.clear();
    store.commit('logout');
    router.push('login');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Logout.vue